import { render, staticRenderFns } from "./LanguagePopover.vue?vue&type=template&id=5c5dc384&"
import script from "./LanguagePopover.vue?vue&type=script&lang=js&"
export * from "./LanguagePopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c5dc384')) {
      api.createRecord('5c5dc384', component.options)
    } else {
      api.reload('5c5dc384', component.options)
    }
    module.hot.accept("./LanguagePopover.vue?vue&type=template&id=5c5dc384&", function () {
      api.rerender('5c5dc384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/language-popover/LanguagePopover.vue"
export default component.exports